var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useContext, useEffect, useState, } from 'react';
import { getIsNewCustomer } from '@ally/data-selectors-transfer-accounts';
import { FeatureFlag } from './FeatureFlag';
var CustomerLimitsContext = createContext({
    isNewCustomer: false,
    newCustomerLimitsEnabled: false,
});
export var CustomerLimitsProvider = function (_a) {
    var _b, _c;
    var _d = _a.hostServices, hostData = _d.hostData, featureFlags = _d.featureFlags, fetch = _d.utils.fetch, children = _a.children;
    var _e = __read(useState(undefined), 2), limits = _e[0], setLimits = _e[1];
    var isNewCustomer = (_c = (_b = getIsNewCustomer(hostData)) === null || _b === void 0 ? void 0 : _b.deposits) !== null && _c !== void 0 ? _c : false;
    var newCustomerLimitsEnabled = featureFlags.variation(FeatureFlag.NewCustomerLimitEnabled, false);
    useEffect(function () {
        function fetchLimit() {
            return __awaiter(this, void 0, void 0, function () {
                var payload;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetch.assets({
                                url: '/json/CustomerLimits.json',
                                method: 'GET',
                            })];
                        case 1:
                            payload = (_a.sent()).payload;
                            setLimits(payload !== null && payload !== void 0 ? payload : undefined);
                            return [2 /*return*/];
                    }
                });
            });
        }
        fetchLimit();
    }, []);
    return (React.createElement(CustomerLimitsContext.Provider, { value: { isNewCustomer: isNewCustomer, limits: limits, newCustomerLimitsEnabled: newCustomerLimitsEnabled } }, children));
};
export var useCustomerLimits = function () {
    return useContext(CustomerLimitsContext);
};
//# sourceMappingURL=useCustomerLimits.js.map